// extracted by mini-css-extract-plugin
module.exports = {"checkboxes-list":"Checkboxes_checkboxes-list__1xUhn","label":"Checkboxes_label__3V_Nd","custom-checkbox":"Checkboxes_custom-checkbox__3TChs"};